"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketListener = void 0;
class WebSocketListener {
    constructor(logger) {
        this.logger = logger;
        this.topicListeners = new Map();
        /**
         *  Used by application to register different listeners for
         *  different message types
         *  @param topic Message topic
         *  @param listener Function to handle message type
         */
        this.addListener = (topic, eventType, listener) => {
            this.logger('WebSocket:addListener', { topic, eventType });
            const key = this.getListenerKey(topic, eventType);
            this.topicListeners.set(key, listener);
        };
        this.getListener = (topic, eventType) => {
            const key = this.getListenerKey(topic, eventType);
            return this.topicListeners.get(key);
        };
        this.removeListener = (topic, eventType) => {
            const key = this.getListenerKey(topic, eventType);
            return this.topicListeners.delete(key);
        };
        this.relayMessageToListener = (message) => {
            if (message.topic === 'NONE')
                return;
            const topicListener = this.getListener(message.topic, message.eventType);
            topicListener === null || topicListener === void 0 ? void 0 : topicListener(message);
        };
        this.getListenerKey = (topic, eventType) => {
            return eventType === undefined ? topic : `${topic}.${eventType}`;
        };
        this.entries = () => this.topicListeners.entries();
    }
    get size() {
        return this.topicListeners.size;
    }
}
exports.WebSocketListener = WebSocketListener;
//# sourceMappingURL=WebSocketListener.js.map